<template>
  <div class="vertical-nav-header d-flex align-center justify-center pt-5 pb-2">
    <router-link
      to="/"
      class="d-flex align-center text-decoration-none"
      tabindex="-1"
    >
      <v-img
        :src="appFullLogoWhite"
        alt="logo"
        class="app-logo sidenav-logo-white"
        contain
        eager
        :width="170"
      ></v-img>

      <v-img
        :src="appFullLogo"
        alt="logo"
        class="app-logo sidenav-logo-black"
        contain
        eager
        :width="170"
      ></v-img>
    </router-link>
  </div>
</template>

<script>
import { mdiRadioboxBlank, mdiRecordCircleOutline, mdiClose } from '@mdi/js'
import useAppConfig from '@core/@app-config/useAppConfig'
import themeConfig from '@themeConfig'
import { inject } from '@vue/composition-api'

export default {
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')

    return {
      menuIsVerticalNavMini,
      isMouseHovered,
      appName: themeConfig.app.name,
      // appLogo: themeConfig.app.logo,
      appFullLogoWhite: themeConfig.app.full_logo_white,
      appFullLogo: themeConfig.app.full_logo,

      // Icons
      icons: {
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}
</style>
